import { AuthInputInterface } from './auth-input.interface';

export class AuthInput implements AuthInputInterface {
  name: string;
  placeholder: string;
  type: string;
  required: boolean;
  minlength: number;
  errorMessage: string;
  validationExp: any;

  constructor(item) {
    this.name = item.name || 'name';
    this.placeholder = item.placeholder || '';
    this.type = item.type || 'text';
    this.required = item.required || false;
    this.minlength = item.required ? item.minLength || 1 : 0;
    this.errorMessage = item.errorMessage || 'Please enter a valid value';
    this.validationExp = item.validationExp || '';
  }
}
